var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivAccountsNotLoggedIn90DaysCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "6gudptvbpa",
    d: "M0 0h16.043v3.46H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2osb0x40qc",
    d: "M0 0h19.956v8.43H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.568 .5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ztmttlur2b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6gudptvbpa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.043.438V3.46H0V.438C0 .197.2 0 .444 0H15.6c.244 0 .444.197.444.438z",
    fill: "#AEB3B7",
    mask: "url(#ztmttlur2b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.166 13.748c-.244.241-.6.372-.933.372H4.568v.942c0 .24.2.438.444.438h15.154a.442.442 0 0 0 .445-.438V8.558c-.734 1.905-1.89 3.657-3.445 5.19z",
    fill: "#AEB3B7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.61 4.836)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9vr9r6perd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2osb0x40qc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.956 0c-.312 3.175-1.667 5.956-4.045 8.3a.442.442 0 0 1-.31.13H.445a.439.439 0 0 1-.4-.262.39.39 0 0 1 .09-.482C2.334 5.518 3.6 2.934 3.912.022h16.043V0z",
    fill: "#AEB3B7",
    mask: "url(#9vr9r6perd)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivAccountsNotLoggedIn90DaysCs);
export default __webpack_public_path__ + "static/media/priv-accounts-not-logged-in-90-days-cs.9ba26b0d.svg";
export { ForwardRef as ReactComponent };